import { Subject } from 'rxjs';
import { WorkItemFind, WorkItemFindResult } from '../../notification/work-item-request';
import { DeferredData, Rpc } from '../rpc';
import { RpcSubjectServer } from '../rpc-subject-server';
import { RpcWorkItemFindHandler } from './rpc-work-item-find-handler';
import { RpcWorkItemFindKey } from './rpc-work-item-find-model';

/**
 * Rpc work item find subject interface.
 */
export interface RpcWorkItemFindSubject extends Subject<DeferredData<WorkItemFind, WorkItemFindResult>> {}

/**
 * The class to implement Rpc work item find with Subject server.
 */
export class RpcWorkItemFindSubjectServer extends RpcSubjectServer<WorkItemFind, WorkItemFindResult> implements RpcWorkItemFindHandler {
    /**
     * Initializes a new instance of the RpcWorkItemFindSubjectServer class.
     */
    constructor(rpc: Rpc) {
        super(rpc, RpcWorkItemFindKey.command);
    }

    /**
     * The handler to respond a request for Work item find call.
     *
     * @param data The work item find object.
     * @return Promise<WorkItemFindResult> the promise object of work item find result.
     */
    public handler(data: WorkItemFind): Promise<WorkItemFindResult> {
        return this.processNextForSubject(RpcWorkItemFindKey.command, data);
    }
}
